import * as React from 'react';
import ListItemText from '@mui/material/ListItemText';
import { CmicContext } from '../../../context/CmicContext';
import { ActionContext } from '../../../context/ActionContext';
import { MessageBarType } from '@fluentui/react';
import { splitLastOccurrence } from '../../../utility/UtilityFunctions';
import { baseFontFamilyStyle } from '../../../shared/styles';

function InputBox({ value, requiredData, labelId, handleCallBackForInputext }) {
	const { currentOfficeTheme, setShowToast } = React.useContext(CmicContext);
	const { selectedAttachmentsIds } = React.useContext(ActionContext);
	const [showInputElement, setShowInputElement] = React.useState(false);
	const [inputValue, setInputValue] = React.useState('');
	const [fileExtension, setFileExtension] = React.useState('');
	const [lastClickTime, setLastClickTime] = React.useState(0);
	const doubleClickDelay = 600;
	const pressTimer = React.useRef(null);

	React.useEffect(() => {
		setInputValue(value);
	}, [value]);

	const truncateString = (str, len) => {
		return str.length > 20 ? str.substring(0, 20) + '...' : str;
	};

	const handleClick = () => {
		const currentTime = new Date().getTime();
		const timeSinceLastClick = currentTime - lastClickTime;

		if (timeSinceLastClick < doubleClickDelay) {
			// Double click
			handleDoubleClick(event);
			setLastClickTime(0);
		} else {
			setLastClickTime(currentTime);
		}
	};

	const handleMouseDown = () => {
		pressTimer.current = setTimeout(() => {
			handleDoubleClick();
		}, 600);
	};

	const handleMouseUp = () => {
		clearTimeout(pressTimer.current);
	};

	const handleDoubleClick = () => {
		if (!(selectedAttachmentsIds[requiredData] === requiredData)) {
			let { attachmentName, extension } = splitLastOccurrence(inputValue);
			setFileExtension(extension);
			setInputValue(attachmentName);
			setShowInputElement(true);
		} else {
			setShowToast({
				isVisible: true,
				msg: `Attachment non-editable`,
				type: MessageBarType.warning,
			});
		}
	};

	const handleChange = event => {
		setInputValue(event.target.value);
	};

	const handleFreezeText = () => {
		if (inputValue.trim()) {
			let conCatenatedInput = inputValue.concat(fileExtension);
			setInputValue(conCatenatedInput);
			handleCallBackForInputext(conCatenatedInput);
			setShowInputElement(false);
		} else {
			let conCatenatedInput = value;
			setInputValue(conCatenatedInput);
			handleCallBackForInputext(conCatenatedInput);
			setShowInputElement(false);
		}
	};

	const handleBlur = () => {
		handleFreezeText();
	};

	const handleKeyPress = event => {
		if (event.charCode === 13) {
			handleFreezeText();
		}
	};

	return (
		<>
			{showInputElement ? (
				<input
					type="text"
					value={inputValue}
					onChange={e => handleChange(e)}
					onBlur={handleBlur}
					maxLength={50}
					onKeyPress={e => {
						handleKeyPress(e);
					}}
					autoFocus
				/>
			) : (
				<ListItemText
					sx={{
						margin: '0px',
						'& .MuiTypography-root': {
							padding: '0px',
							fontFamily: baseFontFamilyStyle,
							color: currentOfficeTheme.bodyForegroundColor,
							width: '100%',
							height: '100%',
							fontSize: '13px',
						},
					}}
					onClick={handleClick}
					onMouseDown={handleMouseDown}
					onMouseUp={handleMouseUp}
					onTouchStart={handleMouseDown}
					onTouchEnd={handleMouseUp}
					id={labelId}
					primary={`${truncateString(inputValue, 25)} `}
				/>
			)}
		</>
	);
}

export default InputBox;
